
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3224c3f0be4850bab3d78193111971ae.jpg"
          alt="岡山の風景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center w-full">
        <p className="text-white text-xs sm:text-sm md:text-lg mb-3 md:mb-4 font-light tracking-wide">
          岡山市・倉敷市・総社市エリアの皆さまへ
        </p>
        <h1 className="text-white text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black mb-4 md:mb-6 leading-tight px-2" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
          家族の未来を守る、<br />
          地域に根ざした保険相談
        </h1>
        <p className="text-white text-sm sm:text-base md:text-xl mb-8 md:mb-12 font-light leading-relaxed max-w-3xl mx-auto px-4" style={{ lineHeight: '1.8' }}>
          創業以来、3,000世帯以上の暮らしに寄り添ってきた実績。<br className="hidden sm:block" />
          あなたのライフステージに最適な保険プランをご提案します
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 px-4">
          <Link
            to="/contact"
            className="w-full sm:w-auto bg-[#FF9B7A] text-white px-8 md:px-10 py-3 md:py-4 rounded-full text-base md:text-lg font-medium hover:bg-[#FF8A65] transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
          >
            無料相談を予約する
            <i className="ri-arrow-right-line text-lg md:text-xl"></i>
          </Link>
          <a
            href="tel:0860123456"
            className="w-full sm:w-auto bg-transparent text-white border-2 border-white px-8 md:px-10 py-3 md:py-4 rounded-full text-base md:text-lg font-medium hover:bg-white hover:text-[#2C3E50] transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line text-lg md:text-xl"></i>
            お電話でのご相談
          </a>
        </div>
      </div>
    </section>
  );
}
